import axios from "axios";

const podcasts = {

    cache: {

    },

    async bulk(params = {}){
        return (await axios.get('/api/podcast', {params})).data;
    },

    async get(short_name){
        if( typeof podcasts.cache[ `get-${short_name}` ] === 'undefined' ){
            podcasts.cache[ `get-${short_name}` ] = (await axios.get(`/api/podcast/${short_name}`)).data;
        }
        return podcasts.cache[ `get-${short_name}` ];
    },

}

export default podcasts;
